import { ChartBar, ClockCounterClockwise, Stack, Play } from "@phosphor-icons/react";
import type { FeaturePalette, ScopeNode } from "@/shared/components/command-palette/types";

const scopes: ScopeNode[] = [
  { id: "mental-math.practice", parentId: "mental-math", title: "Practice", icon: Play, href: "/mental-math/practice" },
  { id: "mental-math.history", parentId: "mental-math", title: "History", icon: ClockCounterClockwise, href: "/mental-math/history" },
  { id: "mental-math.sessions", parentId: "mental-math", title: "Sessions", icon: Stack, href: "/mental-math/sessions" },
  { id: "mental-math.analytics", parentId: "mental-math", title: "Analytics", icon: ChartBar, href: "/mental-math/analytics" },
];

export const mentalMathPalette: FeaturePalette = {
  scopes,
  commands: [
    {
      id: "mental-math.start",
      title: "Start mental math practice",
      icon: Play,
      scopeId: "mental-math",
      keywords: ["practice", "math", "start"],
      run: (ctx) => ctx.router.push("/mental-math/practice"),
    },
  ],
};
